import React, { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import styles from './styles.scss';

export default class Icon extends PureComponent {
  static propTypes = {
    icon: PropTypes.string,
    className: PropTypes.string,
    inverse: PropTypes.bool,
    round: PropTypes.bool,
    id: PropTypes.node,
  };

  static defaultProps = {
    round: true,
    className: '',
  };

  render() {
    const { round, inverse, icon, id } = this.props;
    const className = classNames(this.props.className, {
      [styles.inverse]: inverse,
      [styles.roundIcon]: round,
    });

    return (
      <span className={className}>
        <i id={id} className={`fa-${icon}`} />
      </span>
    );
  }
}
